import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface WebVersionState {
  version: string | null;
}

const initialState: WebVersionState = {
  version: null,
};

const webVersionSlice = createSlice({
  name: 'webVersion',
  initialState,
  reducers: {
    setWebVersion(state, action: PayloadAction<string>) {
      state.version = action.payload;
    },
  },
});

export const { setWebVersion } = webVersionSlice.actions;
export default webVersionSlice.reducer;
